import React, { useCallback, useState } from "react";
import InputWrapper from "./components/InputWrapper"
import "./index.css";

const colorInputs = [
  { id: "redColor", type: "text", colorName: "Red" },
  { id: "greenColor", type: "text", colorName: "Green"},
  { id: "blueColor", type: "text", colorName: "Blue"}
];
const App = () => {
  const [red, setRed] = useState(80);
  const [green, setGreen] = useState(80);
  const [blue, setBlue] = useState(80);
  const [errMessage, setErrMessage] = useState(false);

  const inputStyle = {
    margin: '.5em',
    maxWidth: '2.5em',
    textAlign: 'center',
  }
  const resultColorStyle = {
    margin: "2em auto",
    border: '2px solid black',
    width: "7em", height: "6em",
    background: `rgb(${red}, ${green}, ${blue})`
  }
  const getInputValue = useCallback((id)=> {
    if(id === "redColor") return red;
    if(id === "greenColor") return green;
    if(id === "blueColor") return blue;  
},[red, green, blue]);

  return (
    <div className="container" >
       <h2>RGB Mixer</h2>
       <br />
       <div className="container-inputs-wrapper">
          {colorInputs.map(({ id, type, colorName }) => <InputWrapper colorName={colorName} style={inputStyle} setErrMessage={setErrMessage} setRed={setRed} setGreen={setGreen} setBlue={setBlue} id={id} type={type} value={getInputValue(id)} />)}
       </div>
       <div style={{width: '10em', margin: '1em auto',color: 'red', border: '1px solid red', padding: ".2em", visibility: errMessage? 'visible':'hidden'}}>
         Error
       </div>
       <div id="resultColor" style={resultColorStyle}></div>
    </div>
  );
};
export default App;
